import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
import { Title, Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-ug-bachelor-of-arts',
  templateUrl: './ug-bachelor-of-arts.component.html',
  styleUrls: ['./ug-bachelor-of-arts.component.scss']
})
export class UgBachelorOfArtsComponent implements OnInit {


  constructor(private crudService: CrudService, private titleService: Title, private metaService: Meta) { }

  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
    this.titleService.setTitle("Example of SEO Meta Tag using Angular");  
    
    this.metaService.addTags([
      { name: 'keywords', content: 'Angular SEO Title, Meta Description, Meta Keyword Example' },
      { name: 'robots', content: 'index, follow' },
      { name: 'writer', content: 'John Smith' },
      { charset: 'UTF-8' }
    ]);
  }

}
